import MyTooltip from './MyTooltip';

export default MyTooltip;
